function commaSeparatedToNumberArray(values: string): Array<number> {
  return values.split(',').map((v) => +v.trim());
}

const toAlphaNumeric = (str: string): string => str.replaceAll(/[^a-zA-Z0-9]/g, '');

const capitalize = (s: string): string => (s[0] ?? '').toUpperCase() + s.slice(1);

/**
 * This function primarily targets Windows file basenames since they are the least forgiving.
 * Based off of the reference link's answer contents.
 *
 * @link https://superuser.com/a/358861
 * @param s — the string to format
 * @returns string — the formatted string
 */
const formatSafeBasename = (s: string) => {
  const formatted = (s.length < 240 ? s : s.slice(0, 240)).replace(/[^a-z0-9_-]/gi, '_');
  // Linux does not allow `null` as a file name
  return formatted !== 'null' ? formatted : '_null_';
};

const toSentenceCase = (s: string, delimiter: RegExp | string = /(?=[A-Z])/): string =>
  s && capitalize(s.trim().split(delimiter).join(' ').toLocaleLowerCase());

const trimChars = (s: string, trim: string): string => {
  const regex = new RegExp(`^[${trim}]+|[${trim}]+$`, 'g');
  return s.replace(regex, '');
};

function isNullOrEmptyOrWhitespace(str: string): boolean {
  return !str || str.trim().length === 0;
}

function removeLastCharacterIfS(str: string): string {
  return str.endsWith('s') ? str.slice(0, -1) : str;
}

function isOneOf<const T extends string[]>(str: string, arr: T): str is T[number] {
  return arr.includes(str);
}

export {
  capitalize,
  commaSeparatedToNumberArray,
  formatSafeBasename,
  isNullOrEmptyOrWhitespace,
  isOneOf,
  removeLastCharacterIfS,
  toAlphaNumeric,
  toSentenceCase,
  trimChars,
};
